export default __webpack_public_path__ + "static/media/16.fbfe8f28.png";